export const SUPPORT_EMAIL = 'support@fottur.io';
export const YOGA_CABINET_LINK = 'fottur.com';
